import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/components/BeneficiosSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/components/FeaturedProducts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/components/SobreNosotros.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/CartDrawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Hero.tsx");
